<div class="MessageModal">
    <mat-toolbar>
        <h3>{{ "counting_excel_report" | translate }}</h3>
    </mat-toolbar>
        <mat-dialog-content><br/>
            <div fxLayout.lt-md="row wrap" fxLayoutAlign="center center">
                <button mat-button mat-raised-button color="primary" class="download_button" (click)="onGenerateExcel()">{{ "excel.download" | translate }}</button>
            </div>
            <div fxLayout.lt-md="row wrap" fxLayoutAlign="center center" class="email_text">
                {{'excel.send.email'| translate}}
            </div>
            
                <form [formGroup]="form" autocomplete="off">
                    <mat-form-field appearance="outline">
                        <input matInput autocomplete="off" id="SendMailModal__input" placeholder="Email Address" required #input class="form-control" formControlName="email" (keyup)="onCheckInputEvent($event)">
                        
                    </mat-form-field>
                    <div *ngIf="form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)">
                        <div *ngIf="form.controls['email'].errors.email" class="text-red">{{"error.email" | translate}}</div>
                      </div>
                </form>
 
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-dialog-close mat-button color="secondary">{{ "cancel" | translate }}</button>
            <button id="SendMailModal__submitButton" mat-button color="warn" cdkFocusInitial [disabled]="disabled" (click)="sendReportMail()">{{ "Send" | translate }}</button>
        </mat-dialog-actions>
  </div>